__turbopack_context__.v({
  "mainArea": "MainArea-module__d4IjyG__mainArea",
});
